// useHelmet.js
import { Helmet } from 'react-helmet-async';
export const setHelmet = (title ) => {  
    return (
      <Helmet>
        <title>{title}</title>
      </Helmet>
    );
  };
